var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box"},[_c('input',{attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}}),_c('span',{staticClass:"icon material-icons-outlined"},[_vm._v("search")])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }